<template lang="pug" src="./newsEditor.pug"></template>
<style lang="scss" src="./newsEditor.scss" scoped></style>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import config from '../../../config.json'
import validate from '@/mixins/validate'
import MarkdownEditor from '@/components/MarkdownEditor'
import Vue from 'vue'

export default {
    components: {
        'markdown-editor': MarkdownEditor
    },
    mixins: [validate, validationMixin],
    data: () => ({
        publicationMaxLength: config.publicationMaxLength,
        feed: {
            header: null,
            publicationDate: null,
            text: '',
            showTo: {
                text: 'all',
                value: null
            },
            showText: false,
            image: null,
            isLatePublication: false,
            uuid: null
        },
        fd: new FormData(),
        selectedFile: null,
        publicationTime: null,
        canSaveChanges: false,
        showPreview: false
    }),
    validations: {
        feed: {
            header: {
                required
            },
            publicationDate: {
                required: requiredIf(function() {
                    return this.feed.isLatePublication
                })
            },
            text: {
                required: requiredIf(function() {
                    return this.feed.showText
                }),
                maxLength: function() {
                    return this.feed.text.length <= this.publicationMaxLength
                }
            }
        },
        publicationTime: {
            required: requiredIf(function() {
                return this.feed.isLatePublication
            })
        }
    },
    computed: {
        isEditing() {
            return this.$route.params.id
        },
        saveText() {
            return this.isEditing ? 'update' : 'create'
        },
        saveAction() {
            return this.isEditing ? 'updateFeed' : 'createFeed'
        },
        showToSelects() {
            const typeSelects = '$vuetify.pages.News.selects'
            return ['all', 'leader', 'business'].map(it => ({
                text: this.$vuetify.t(`${typeSelects}.${it}`),
                value: it === 'all' ? null : it
            }))
        },
        maxPublicationDate: function() {
            return new Date().addDays(100).toJSON()
        },
        minPublicationDate: function() {
            return new Date().addDays(-1).toJSON()
        },
        minPublicationTime: function() {
            if (new Date().toDateString() === new Date(this.feed.publicationDate).toDateString()) {
                return new Date(this.minPublicationDate).format('%H:%M:%S')
            }
            return '00:00:00'
        },
        publicationDate() {
            return this.createUtcDate(this.feed.publicationDate, this.publicationTime)
        },
        canShowPublicationDate() {
            return this.isEditing &&
                !this.feed.isLatePublication &&
                this.feed.publicationDate
        }
    },
    watch: {
        feed: {
            handler() {
                this.canSaveChanges = true
            },
            deep: true
        },
        publicationTime() {
            this.canSaveChanges = true
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        openFileDialog: function() {
            this.$refs.imageUploader.click()
        },
        setImage: async function(event) {
            const image = event.target.files[0]
            this.selectedFile = image.name
            this.feed.image = image
        },
        changeText(text) {
            this.feed.text = text
        },
        changePublicationDate: function(date) {
            this.publicationTime = null
            this.feed.publicationDate = date
        },
        changePublicationTime: function(time) {
            this.publicationTime = time
        },
        onShowTextChange(value) {
            this.feed.text = ''
        },
        resetPickers: function() {
            this.feed.publicationDate = null
            this.publicationTime = null
        },
        async loadData() {
            if (this.isEditing) {
                const newsId = this.$route.params.id

                await this.$store.dispatch('news/getNewsById', newsId).then(res => {
                    if (res.status === 200 && res.data) {
                        this.processResponseData(res.data)
                    }
                })
            }
        },
        processResponseData(data) {
            this.feed = Object.assign({}, Object.select(data, [
                'id', ...Object.keys(this.feed)
            ]), {
                publicationDate: Vue.filter('onlyDay')(data.publicationDate),
                image: null
            })

            this.publicationTime = Vue.filter('onlyTime')(data.publicationDate)
            this.selectedFile = data.image.originalname

            if (this.feed.id && !this.isEditing) {
                this.$router.push(`/news/editor/${this.feed.id}`)
            }

            this.$nextTick(() => {
                this.canSaveChanges = false
                this.$v.$reset()
            })
        },
        submitFeed: function() {
            if (this.$v.$invalid) {
                this.$v.$touch()
                return
            }

            if (!this.feed.isLatePublication && !this.feed.publicationDate) {
                const currentDate = new Date()
                this.feed.publicationDate = currentDate.format('{yyyy}-{M}-{dd}')
                this.publicationTime = currentDate.format('%H:%M:%S')
            }

            this.composeFormData(
                Object.assign({}, this.feed, {
                    publicationDate: this.publicationDate
                })
            )

            this.$store.dispatch(`news/${this.saveAction}`, this.fd)
                .then(res => {
                    if (res.status === 200 && res.data && res.data.news) {
                        this.processResponseData(res.data.news)
                    }
                }).finally(() => {
                    this.canSaveChanges = false
                })
        },
        createUtcDate(day, time) {
            return Date.create(
                `${day}T${time}`,
                { setUTC: true }
            )
        },
        composeFormData: function(data) {
            Object.keys(this.feed).map(it => {
                this.fd.set(it, data[it])
            })
        }
    }
}
</script>
